var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAvatarChat1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_avatar_chat_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_avatar_chat_1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_pattern_3906560",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.68408,8.333 L0.02563,24.99146 L16.68408,41.6499 L33.34253,24.99146 L16.68408,8.333 Z M16.67808,36.57781 L5.10022,25 L16.678,13.42218 L28.25586,25 L16.67808,36.57781 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.64392,25 L66.65247,24.99146 L50.006,8.345 L33.35962,24.99146 L50.006,41.63788 L66.64392,25 Z M50.01208,13.42218 L61.5899,25 L50.01208,36.57782 L38.43427,25 L50.01208,13.42218 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.66956,24.99146 L83.322,41.64386 L99.97441,24.99146 L83.322,8.339 L66.66956,24.99146 Z M83.322,36.57782 L71.74414,25 L83.322,13.42218 L94.89978,25 L83.322,36.57782 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "3.597 41.661 0.017 38.081 0 38.098 0 45.224 0.017 45.241"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "96.403 41.661 99.983 45.241 100 45.224 100 38.098 99.983 38.081"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(33.351089, 41.660969) rotate(-45.000490) translate(-33.351089, -41.660969) ",
    x: 30.8198745,
    y: 39.1297539,
    width: 5.06243,
    height: 5.06243
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(66.660991, 41.660964) rotate(-45.000490) translate(-66.660991, -41.660964) ",
    x: 64.1297763,
    y: 39.1297492,
    width: 5.06243,
    height: 5.06243
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "24.995 0 19.917 0 16.678 3.239 13.439 0 8.373 0 16.684 8.311"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "58.305 0 53.251 0 50.012 3.239 46.773 0 41.707 0 50.006 8.299"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "91.627 0 86.561 0 83.322 3.239 80.083 0 75.017 0 83.322 8.305"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "3.597 8.322 0.017 4.742 0 4.759 0 11.885 0.017 11.902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "96.403 8.322 99.983 11.902 100 11.885 100 4.759 99.983 4.742"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(33.351083, 8.321947) rotate(-44.999510) translate(-33.351083, -8.321947) ",
    x: 30.8198685,
    y: 5.79073239,
    width: 5.06243,
    height: 5.06243
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(66.660995, 8.321942) rotate(-45.000000) translate(-66.660995, -8.321942) ",
    x: 64.1297803,
    y: 5.79072714,
    width: 5.06243,
    height: 5.06243
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.01709,58.322 L16.68409,74.989 L33.33409,58.339 L33.34509,58.32795 L16.678,41.661 L0.00854,58.33044 L0,58.339 L6e-05,58.339 L0.01709,58.322 Z M16.678,46.76117 L28.25586,58.339 L16.678,69.91681 L5.10022,58.339 L16.678,46.76117 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.66705,58.31586 L50.01208,41.661 L33.35108,58.322 L50.00608,74.977 L66.661,58.322 L83.322,74.983 L99.983,58.322 L83.322,41.661 L66.66705,58.31586 Z M50.01205,69.91681 L38.43427,58.339 L50.01208,46.76117 L61.5899,58.339 L50.01205,69.91681 Z M83.32193,69.91681 L71.74414,58.339 L83.322,46.76117 L94.89978,58.339 L83.32193,69.91681 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "3.597 75 0.017 71.42 0 71.437 0 78.563 0.017 78.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "96.403 75 99.983 78.58 100 78.563 100 71.437 99.983 71.42"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(33.351086, 74.999990) rotate(-45.000000) translate(-33.351086, -74.999990) ",
    x: 30.8198713,
    y: 72.4687746,
    width: 5.06243,
    height: 5.06243
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(66.661000, 74.999980) rotate(-45.000490) translate(-66.661000, -74.999980) ",
    x: 64.129785,
    y: 72.4687647,
    width: 5.06243,
    height: 5.06243
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "16.678 75 0.017 91.661 8.356 100 13.422 100 5.1 91.678 16.678 80.1 28.256 91.678 19.934 100 25.012 100 33.345 91.667"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "83.322 75 66.667 91.655 50.012 75 33.351 91.661 41.69 100 46.756 100 38.434 91.678 50.012 80.1 61.59 91.678 53.268 100 58.322 100 66.644 91.678 66.661 91.661 75 100 80.066 100 71.744 91.678 83.322 80.1 94.9 91.678 86.578 100 91.644 100 99.983 91.661"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatarChat1);
export default __webpack_public_path__ + "static/media/icon_avatar_chat_1.f55d005039d554b9e8811ef39bf5c2c0.svg";
export { ForwardRef as ReactComponent };